































































































import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import Competence from '@/competences/entities/competence.vue'
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class CompetencesTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public competences!: Competence[]

  @Prop({ type: Boolean, default: false })
  private hideRating!: boolean

  @Prop({ type: Boolean, default: false })
  public disabled!: boolean

  private get headers() {
    const columns: object[] = [
      {
        text: this.$tc('competences.entities.competence.title'),
        value: 'title',
        width: '25%',
        sortable: false,
      },
      {
        text: this.$tc('competences.entities.competence.description'),
        value: 'desctiption',
        sortable: false,
      },
    ]

    if (this.hideRating === false) {
      columns.push({
        text: this.$tc('competences.entities.competence.rating'),
        value: 'rating',
        sortable: false,
        align: 'center',
      })
    }

    columns.push({
      text: '',
      value: 'action',
      sortable: false,
      cellClass: 'table-actions',
      align: 'end',
    })

    return columns
  }
}
